import React, { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { IonIcon } from "@ionic/react";
import { pencilOutline } from "ionicons/icons";

export default function EditableTitle({ editLabel, showIcon = true, ...props }) {
  const inputRef = useRef(null);
  return (
    <div className="d-inline-flex align-items-center gap-1" style={{ minWidth: 0, maxWidth: "100%" }}>
      <span className="position-relative" style={{ minWidth: 0, flex: "0 1 auto" }}>
        <span
          aria-hidden="true"
          className={`form-control ${props.className || ""}`}
          style={{ visibility: "hidden", whiteSpace: "pre", width: "auto", minWidth: "2ch", overflow: "hidden" }}
        >
          {String(props.value || props.placeholder || "")}&#8202;
        </span>
        <Form.Control {...props} ref={inputRef}
          style={{ position: "absolute", inset: 0, width: "100%", minWidth: 0 }} />
      </span>
      {showIcon && <Button
        type="button"
        variant="link"
        className="text-secondary p-1 flex-shrink-0 d-flex align-items-center"
        title={editLabel}
        aria-label={editLabel}
        onClick={() => {
          inputRef.current?.focus();
          inputRef.current?.select();
        }}
      >
        <IonIcon icon={pencilOutline} aria-hidden="true" />
      </Button>}
    </div>
  );
}
